module.exports = __webpack_public_path__ + "static/media/Thomas Jefferson - 1804.cdd7a595.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Thomas Jefferson - 1804.jpg
// module id = 556
// module chunks = 0